import { useState } from 'react';
import { Drawer } from 'antd';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { MenuOutlined } from '@ant-design/icons';

import Text from '@/v2/components/Typography/Text';
import Colors from '@/v2/constants/Colors';
import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';

import menuItems from '../menuItems';
import MenuButtons from '../MenuButtons/MenuButtons';
import {
  BurgerButton,
  ButtonsContainer,
  ItemsContainer,
} from './BurgerMenu.styled';

export default function BurgerMenu() {
  const router = useRouter();
  const currentPath = router.asPath;
  const [drawerVisible, setDrawerVisible] = useState(false);
  const plausibleContext = usePlausibleContext();

  const openDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);

  const handlePlausibleEvent = (event, props) => {
    if (event) {
      plausibleContext.actions.sendPlausibleEvent(event, props);
    }
  };

  return (
    <>
      <BurgerButton onClick={openDrawer}>
        <MenuOutlined className="icon" />
      </BurgerButton>
      <Drawer
        headerStyle={null}
        placement="right"
        onClose={closeDrawer}
        visible={drawerVisible}
      >
        <ItemsContainer>
          {menuItems.map((item) => (
            <Link
              href={item.href}
              key={item.href}
              onClick={() =>
                handlePlausibleEvent(item.plausibleEvent, item.plausibleProps)
              }
            >
              <Text
                variant="cardTitle"
                color={
                  currentPath == item.href
                    ? Colors.ACCENT_VARIANTS[90]
                    : Colors.BLUE
                }
              >
                {item.label}
              </Text>
            </Link>
          ))}
        </ItemsContainer>
        <ButtonsContainer>
          <MenuButtons onClickButton={closeDrawer} />
        </ButtonsContainer>
      </Drawer>
    </>
  );
}
